import { VueConstructor } from 'vue';
import { CoreOptions } from '../../index';
import StorageFactory from './storagefactory';
import IStorage from './istorage';

declare module 'vue/types/vue' {
  interface Vue {
    $localStorage: IStorage
    $sessionStorage: IStorage
  }
  interface VueConstructor {
    $localStorage: IStorage
    $sessionStorage: IStorage
  }
}

export default {
  install: (Vue: VueConstructor, options: CoreOptions) => {
    const appNamespace = Vue.$version.name ?? 'glittr';
    Vue.$localStorage = new StorageFactory(Vue, window.localStorage, appNamespace, 'localStorage');
    Vue.$sessionStorage = new StorageFactory(Vue, window.sessionStorage, appNamespace, 'sessionStorage');

    Vue.prototype.$localStorage = Vue.$localStorage;
    Vue.prototype.$sessionStorage = Vue.$sessionStorage;
  },
};
